import React, { useEffect, useMemo, useState, useRef } from 'react';
import { Pencil, Trash, Eye, Plus, ChevronDown, Info as InfoIcon, CirclePlus } from 'lucide-react';
import PaginationComponent from '../../shared/components/PaginationComponent';
import AddEditCommanTasks from '../components/forms/AddEditCommanTasksTemplate';
import BulkCreateGroupTaskTemplate from '../components/forms/BulkCreateGroupTaskTemplate';
import Modal from '../../shared/components/ui/Modal';
import {
  createTaskTemplate,
  createBulkTaskTemplates,
  createWorkType,
  deleteTaskTemplate,
  deleteWorkType,
  getAllAccommodationTaskTemplates,
  getAllWorkTypes,
  handleCheckWorkTypeDelete,
  updateTaskTemplate,
  updateWorkType
} from '../services/api/implementation/impl';
import { useMutation, useQuery } from '@tanstack/react-query';
import AddEditWorkType from '../components/forms/AddEditWorkType';
import toast from 'react-hot-toast';
import AddEditAccoGroupTaskTemplate from '../components/forms/AddEditAccoGroupTaskTemplate';
import Button from '../../shared/components/ui/Button';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import DeleteConfirmationModal from '../components/ui/DeleteConfirmationModal';

const GroupTasks = ({
  setisLoading,
  TaskTemplates,
  projectId,
  triggerBulkCreate,
  bulkCreateTemplateName,
  refreshtemplates
}) => {
  const userId = Cookies.get('userId');
  const [showIdleInfo, setShowIdleInfo] = useState(false);
  const [isOpenAddEditModal, setIsOpenAddEditModal] = useState(false);
  const [isBulkCreateModalOpen, setIsBulkCreateModalOpen] = useState(false);
  const [modalType, setModalType] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [expandedTasks, setExpandedTasks] = useState([]);
  const [previousTask, setPreviousTask] = useState();
  const [isOpenAddWTModal, setIsOpenAddWTModal] = useState(false);
  const [workTypeId, SetWorkTypeId] = useState();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState();
  const [taskPositionType, setTaskPositionType] = useState();
  const [errorMessage, setErrorMessage] = useState(null);
  const [activeTab, setActiveTab] = useState(0); // Default to first tab
  const [isOpenEditWTModal, setIsOpenEditWTModal] = useState(false);
  const [isOpenSelectWTModal, setIsOpenSelectWTModal] = useState(false);
  const [selectedWorkType, setSelectedWorkType] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [hoverTimeout, setHoverTimeout] = useState(null);
  const [canDelete, setCanDelete] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [resData, setResData] = useState();
  const [buttonType, setButtonType] = useState('');
  const [worktypeFilter, setWorktypeFilter] = useState('');
  const [openDropdown, setOpenDropdown] = useState(null);
  const worktypeHeaderRef = useRef(null);
  const [bulkMode, setBulkMode] = useState('create');

  const {
    data: allTasks,
    refetch: refetchCommonTaskTemplates,
    isFetching
  } = useQuery({
    queryKey: ['getAllAccommodationTaskTemplates', 'Group', projectId, activeTab, worktypeFilter],
    queryFn: () =>
      getAllAccommodationTaskTemplates(
        'Group',
        projectId,
        TaskTemplates?.[activeTab]?.name,
        worktypeFilter
      ),
    keepPreviousData: true,
    enabled: !!projectId && !!TaskTemplates?.length
  });

  const { data: AllWorkTypes, refetch: fetchWorkTypes } = useQuery({
    queryKey: ['AllWorkTypes'],
    queryFn: getAllWorkTypes
  });

  // Track page view
  useEffect(() => {
    mixpanel.track('Group Tasks Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    setisLoading(isFetching);
  }, [isFetching]);

  //refetch vendors when component mounts
  useEffect(() => {
    refetchCommonTaskTemplates();
    fetchWorkTypes();
  }, []);

  // Open bulk create modal when triggered from parent
  useEffect(() => {
    if (triggerBulkCreate) {
      setBulkMode('create');
      setIsBulkCreateModalOpen(true);
    }
  }, [triggerBulkCreate]);

  // Handle tab change
  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
    // Track tab change
    mixpanel.track('Group Task Template Tab Changed', {
      user_id: userId,
      tab_index: tabIndex,
      template_id: TaskTemplates?.[tabIndex]?.id,
      template_name: TaskTemplates?.[tabIndex]?.name,
      timestamp: new Date().toISOString()
    });
  };

  //stare the all vendors in the vendors state
  useEffect(() => {
    if (allTasks?.data) {
      setTasks(allTasks?.data);
    }
  }, [allTasks?.data]);

  // function formatTasksByWorkType(tasks) {
  //   const grouped = {};

  //   tasks.forEach((task) => {
  //     const workTypeName = task.workType.name;
  //     if (!grouped[workTypeName]) {
  //       grouped[workTypeName] = [];
  //     }
  //     grouped[workTypeName].push(task);
  //   });

  //   const formatted = [];

  //   for (const [workType, taskList] of Object.entries(grouped)) {
  //     const [first, ...rest] = taskList;

  //     const formattedGroup = {
  //       id: first.id,
  //       workType: workType,
  //       taskId: first.id,
  //       workType_id: first.workType_id,
  //       name: first.name,
  //       duration: `${first.duration} day${first.duration > 1 ? 's' : ''}`,
  //       // dependentTasks: (first.dependencies?.map((item) => item.name) || []).join(', ') || '-',
  //       dependentTasks:
  //         (first.dependencies?.map((item) => item.dependency?.name) || []).join(', ') || '-',

  //       idleTime: `${first.delay} day${first.delay > 1 ? 's' : ''}`,
  //       drawingRequired: first.drawing_required ? 'Yes' : 'No',
  //       Others: rest.map((task, i) => ({
  //         id: task.id,
  //         taskId: task.id,
  //         name: task.name,
  //         workType: task.workType,
  //         workType_id: task.workType_id,
  //         duration: `${task.duration} day${task.duration > 1 ? 's' : ''}`,
  //         dependentTasks:
  //           (task.dependencies?.map((item) => item.dependency?.name) || []).join(', ') || '-',
  //         idleTime: `${task.delay} day${task.delay > 1 ? 's' : ''}`,
  //         drawingRequired: task.drawing_required ? 'Yes' : 'No'
  //       }))
  //     };

  //     formatted.push(formattedGroup);
  //   }

  //   return formatted;
  // }

  // const formatted = useMemo(() => formatTasksByWorkType(tasks), [tasks]);
  const formatted = tasks; // Use tasks directly - filtering is done on backend

  // useEffect(() => {
  //   const allExpandableTaskIds = formatted
  //     .filter((task) => task.Others?.length)
  //     .map((task) => task.id);
  //   setExpandedTasks(allExpandableTaskIds);
  // }, [formatted]);

  const toggleExpand = (taskId) => {
    const isCurrentlyExpanded = expandedTasks.includes(taskId);
    // Track expand/collapse action
    mixpanel.track('Group Task Expand Toggle', {
      user_id: userId,
      task_id: taskId,
      action: isCurrentlyExpanded ? 'collapse' : 'expand',
      timestamp: new Date().toISOString()
    });
    setExpandedTasks((prev) =>
      prev.includes(taskId) ? prev.filter((id) => id !== taskId) : [...prev, taskId]
    );
  };

  const { mutate: handleCreateTask } = useMutation({
    mutationFn: (payload) =>
      modalType === 'Add'
        ? createTaskTemplate(payload)
        : updateTaskTemplate(previousTask?.id, payload),
    onMutate: () => {
      setIsSubmitting(true);
      // Track API call initiation
      mixpanel.track(`Group Task ${modalType === 'Add' ? 'Create' : 'Update'} Initiated`, {
        user_id: userId,
        action: modalType,
        task_position_type: taskPositionType,
        work_type_id: workTypeId || previousTask?.workType_id,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: async (data) => {
      setIsSubmitting(false);
      // Track API success
      mixpanel.track(`Group Task ${modalType === 'Add' ? 'Create' : 'Update'} Success`, {
        user_id: userId,
        action: modalType,
        task_position_type: taskPositionType,
        work_type_id: workTypeId || previousTask?.workType_id,
        timestamp: new Date().toISOString()
      });
      toast.success(`Task ${modalType === 'Add' ? 'created' : 'updated'} successfully`);
      setPreviousTask('');
      SetWorkTypeId();
      setIsOpenAddEditModal(false);
      setTaskPositionType();
      setSelectedTask();
      await refetchCommonTaskTemplates();
    },
    onError: (err) => {
      setIsSubmitting(false);
      // Track API failure with comprehensive error details
      mixpanel.track(`Group Task ${modalType === 'Add' ? 'Create' : 'Update'} Failed`, {
        user_id: userId,
        action: modalType,
        task_position_type: taskPositionType,
        work_type_id: workTypeId || previousTask?.workType_id,
        // Comprehensive error tracking
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        error_code: err?.response?.data?.code || err?.code || 'N/A',
        http_status: err?.response?.status || 'N/A',
        http_status_text: err?.response?.statusText || 'N/A',
        api_endpoint: err?.config?.url || 'N/A',
        request_method: err?.config?.method?.toUpperCase() || 'N/A',
        error_type: err?.name || 'Unknown',
        full_error_response: err?.response?.data || err?.message || 'No details',
        timestamp: new Date().toISOString()
      });
      console.error(`Error ${modalType === 'Add' ? 'creating new' : 'updating'}  task`, err);
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          `Error ${modalType === 'Add' ? 'creating new' : 'updating'} task`
      );
    }
  });

  const { mutate: handleCreateWorkType } = useMutation({
    mutationFn: (data) => createWorkType(data),
    onMutate: () => {
      setIsSubmitting(true);
      // Track WorkType creation initiation
      mixpanel.track('Group WorkType Create Initiated', {
        user_id: userId,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: async (data) => {
      setIsSubmitting(false);
      // Track WorkType creation success
      mixpanel.track('Group WorkType Create Success', {
        user_id: userId,
        timestamp: new Date().toISOString()
      });
      toast.success(`WorkType ${modalType === 'Add' ? 'created' : 'updated'} successfully`);
      await Promise.all([refetchCommonTaskTemplates(), fetchWorkTypes()]);
      setIsOpenAddWTModal(false);
    },
    onError: (err) => {
      setIsSubmitting(false);
      // Track WorkType creation failure with comprehensive error details
      mixpanel.track('Group WorkType Create Failed', {
        user_id: userId,
        // Comprehensive error tracking
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        error_code: err?.response?.data?.code || err?.code || 'N/A',
        http_status: err?.response?.status || 'N/A',
        http_status_text: err?.response?.statusText || 'N/A',
        api_endpoint: err?.config?.url || 'N/A',
        request_method: err?.config?.method?.toUpperCase() || 'N/A',
        error_type: err?.name || 'Unknown',
        full_error_response: err?.response?.data || err?.message || 'No details',
        timestamp: new Date().toISOString()
      });
      console.error(`Error ${modalType === 'Add' ? 'creating new' : 'updating'}  worktype`, err);
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          `Error ${modalType === 'Add' ? 'creating new' : 'updating'} worktype`
      );
    }
  });

  const handleAddTask = (data) => {
    const payload = workTypeId
      ? {
          ...data,
          workType_id: workTypeId
        }
      : {
          ...data,
          prev_template_id: previousTask.id,
          workType_id: previousTask.workType_id
        };

    handleCreateTask(payload);
  };

  const { mutate: handleUpdateWorkType } = useMutation({
    mutationFn: ({ id, data }) => updateWorkType(id, data),
    onMutate: () => {
      setIsSubmitting(true);
      // Track WorkType update initiation
      mixpanel.track('WorkType Update Initiated', {
        user_id: userId,
        work_type_id: selectedWorkType?.id,
        work_type_name: selectedWorkType?.name,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      // Track WorkType update success
      mixpanel.track('WorkType Update Success', {
        user_id: userId,
        work_type_id: selectedWorkType?.id,
        work_type_name: selectedWorkType?.name,
        timestamp: new Date().toISOString()
      });
      toast.success('WorkType updated successfully');
      setIsOpenEditWTModal(false);
      setSelectedWorkType(null);
      await Promise.all([refetchCommonTaskTemplates(), fetchWorkTypes()]);
    },
    onError: (err) => {
      setIsSubmitting(false);
      // Track WorkType update failure with comprehensive error details
      mixpanel.track('WorkType Update Failed', {
        user_id: userId,
        work_type_id: selectedWorkType?.id,
        work_type_name: selectedWorkType?.name,
        // Comprehensive error tracking
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        error_code: err?.response?.data?.code || err?.code || 'N/A',
        http_status: err?.response?.status || 'N/A',
        http_status_text: err?.response?.statusText || 'N/A',
        api_endpoint: err?.config?.url || 'N/A',
        request_method: err?.config?.method?.toUpperCase() || 'N/A',
        error_type: err?.name || 'Unknown',
        full_error_response: err?.response?.data || err?.message || 'No details',
        timestamp: new Date().toISOString()
      });
      console.error('Error updating worktype', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error updating worktype');
    }
  });

  const handleOnEdit = (id) => {
    const task = tasks.find((item) => item.id === Number(id)); // Use find() instead of filter()

    if (task) {
      // Track edit button click
      mixpanel.track('Group Task Edit Button Clicked', {
        user_id: userId,
        task_id: id,
        task_name: task.name,
        work_type: task.workType?.name,
        timestamp: new Date().toISOString()
      });
      setIsOpenAddEditModal(true);
      setModalType('Edit');
      setPreviousTask(task);
    }
  };

  const handleAddWT = (data) => {
    handleCreateWorkType(data);
  };

  const handleEditWT = (data) => {
    handleUpdateWorkType({ id: selectedWorkType.id, data });
  };

  const handleEditWorkTypeClick = () => {
    // Track edit work type button click
    mixpanel.track('Edit WorkType Button Clicked', {
      user_id: userId,
      location: 'action_bar',
      timestamp: new Date().toISOString()
    });
    setButtonType('edit');
    setIsOpenSelectWTModal(true);
  };

  const handleWorkTypeSelection = (workType) => {
    setSelectedWorkType(workType);
    setIsOpenSelectWTModal(false);
    if (buttonType === 'edit') {
      setIsOpenEditWTModal(true);
      setModalType('Edit');
    }
    if (buttonType === 'delete') {
      handleCheckDelete(workType.id);
    }
  };

  const handleDeleteWorkTypeClick = () => {
    // Track delete work type button click
    mixpanel.track('Delete WorkType Button Clicked', {
      user_id: userId,
      location: 'action_bar',
      timestamp: new Date().toISOString()
    });
    setButtonType('delete');
    setIsOpenSelectWTModal(true);
  };

  const transformedDataWorkTypes =
    AllWorkTypes?.filter((item) => item.type === 'Accomodation')?.map((item) => ({
      label: item.name || '',
      id: item.id,
      value: item.id,
      type: item.type,
      is_added: item.is_added
    })) || [];

  const availableWorkTypes = useMemo(() => {
    if (!transformedDataWorkTypes.length || !tasks.length) return [];
    const workTypeIdsWithTasks = new Set(tasks.map((t) => t.workType_id));
    return transformedDataWorkTypes.filter((wt) => !workTypeIdsWithTasks.has(wt.id));
  }, [transformedDataWorkTypes, tasks]);

  const workTypesWithoutTasks = useMemo(() => {
    // If a worktype filter is applied, only show that worktype if it has no tasks
    if (worktypeFilter) {
      return availableWorkTypes.filter((wt) => wt.id === parseInt(worktypeFilter));
    }
    return availableWorkTypes;
  }, [availableWorkTypes, worktypeFilter]);

  const handleDelete = () => {
    const id = Number(selectedTask);
    handleDeleteTaskTemplate(id);
  };

  const { mutate: handleDeleteTaskTemplate } = useMutation({
    mutationFn: (id) => deleteTaskTemplate(id),
    onMutate: () => {
      setIsSubmitting(true);
      // Track delete initiation
      mixpanel.track('Group Task Delete Initiated', {
        user_id: userId,
        task_id: selectedTask,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      // Track delete success
      mixpanel.track('Group Task Delete Success', {
        user_id: userId,
        task_id: selectedTask,
        timestamp: new Date().toISOString()
      });
      toast.success(`Task Template deleted successfully`);
      await Promise.all([refetchCommonTaskTemplates(), fetchWorkTypes()]);
      setOpenDeleteModal(false);
      setErrorMessage(null);
    },
    onError: (err) => {
      setIsSubmitting(false);
      // Track delete failure with comprehensive error details
      mixpanel.track('Group Task Delete Failed', {
        user_id: userId,
        task_id: selectedTask,
        // Comprehensive error tracking
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        error_code: err?.response?.data?.code || err?.code || 'N/A',
        http_status: err?.response?.status || 'N/A',
        http_status_text: err?.response?.statusText || 'N/A',
        api_endpoint: err?.config?.url || 'N/A',
        request_method: err?.config?.method?.toUpperCase() || 'N/A',
        error_type: err?.name || 'Unknown',
        has_dependencies:
          err?.message?.includes('dependencies') ||
          err?.response?.data?.message?.includes('dependencies') ||
          false,
        full_error_response: err?.response?.data || err?.message || 'No details',
        timestamp: new Date().toISOString()
      });
      setErrorMessage(err?.response?.data?.message || err?.message);
    }
  });

  useEffect(() => {
    setisLoading(isSubmitting);
  }, [isSubmitting]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openDropdown &&
        worktypeHeaderRef.current &&
        !worktypeHeaderRef.current.contains(event.target)
      ) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openDropdown]);

  //delete functions

  const { mutate: handleCheckDelete } = useMutation({
    mutationFn: (id) => handleCheckWorkTypeDelete(id),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res, id) => {
      setIsSubmitting(false);
      const workType = transformedDataWorkTypes?.find((item) => parseInt(item.id) === parseInt(id));
      const workTypeName = workType?.label || 'WorkType';
      if (res.canDelete) {
        setCanDelete('yes');
        setSelectedIds([parseInt(id)]);
        setResData({ name: workTypeName });
      } else {
        setCanDelete('no');
        setResData({ ...res, name: workTypeName });
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error checking dependencies', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking dependencies');
    }
  });

  const { mutate: handleDeleteFn } = useMutation({
    mutationFn: (payload) => deleteWorkType(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: () => {
      setIsSubmitting(false);
      toast.success('WorkType Deleted Successfully');
      fetchWorkTypes();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting workType', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting workType');
    }
  });

  const HandleDelete = (data) => {
    const payload = { ids: data };
    handleDeleteFn(payload);
  };

  const handleBulkCreateTasks = async (templates) => {
    setIsSubmitting(true);
    try {
      // Track bulk create initiation
      mixpanel.track('Bulk Create Group Tasks Initiated', {
        user_id: userId,
        tasks_count: templates.length,
        timestamp: new Date().toISOString()
      });

      // Create payload with new structure
      const payload = {
        project_id: projectId,
        template_name:
          bulkMode === 'edit' ? TaskTemplates?.[activeTab]?.name : bulkCreateTemplateName,
        templates: templates
      };

      // Create all tasks with single API call
      await createBulkTaskTemplates(payload);

      // Track success
      mixpanel.track('Bulk Create Group Tasks Success', {
        user_id: userId,
        tasks_count: templates.length,
        timestamp: new Date().toISOString()
      });
      setIsBulkCreateModalOpen(false);
      toast.success(
        `Successfully ${bulkMode === 'edit' ? 'updated' : 'created'}  ${templates.length} tasks`
      );
      refetchCommonTaskTemplates();
      refreshtemplates?.();
    } catch (err) {
      // Track failure
      mixpanel.track(`Bulk ${bulkMode === 'edit' ? 'update' : 'create'} Group Tasks Failed`, {
        user_id: userId,
        tasks_count: templates.length,
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
      console.error(`Error bulk ${bulkMode === 'editing' ? 'updating' : 'created'} tasks`, err);
      toast.error(err?.response?.data?.message || err?.message || 'Error creating tasks');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="mt-[13.5rem] relative">
      {openDeleteModal && (
        <Modal
          isDirty
          confirmOnClose
          width={45}
          name="Delete Task Template"
          onClose={() => {
            setOpenDeleteModal(false);
            setErrorMessage(null);
          }}>
          <div className="flex flex-col justify-start items-center z-10">
            <h1 className=" text-center text-[1.4rem] font-medium text-primary">
              {errorMessage
                ? 'This template task has following dependencies:'
                : 'Are you sure you want to delete this task template?'}
            </h1>
            {errorMessage && (
              <div className="flex justify-start, align-middle flex-wrap bg-[#f5f7f8] p-2 rounded-[5px] mt-4 w-full">
                {errorMessage}
              </div>
            )}
            {!errorMessage && (
              <div className="w-full flex justify-end items-center space-x-4 mt-8">
                <Button
                  type="reset"
                  onClick={() => setOpenDeleteModal(false)}
                  displayType="secondary">
                  Cancel
                </Button>

                <Button
                  disabled={isSubmitting}
                  type="button"
                  onClick={(e) => {
                    e.preventDefault(); // extra safety
                    handleDelete();
                  }}
                  displayType="primary-red">
                  Delete
                </Button>
              </div>
            )}
          </div>
        </Modal>
      )}

      {isOpenAddEditModal && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={50}
          name={modalType === 'Edit' ? 'Edit Task' : 'Add Task'}
          onClose={() => setIsOpenAddEditModal(false)}>
          <AddEditAccoGroupTaskTemplate
            isSubmitting={isSubmitting}
            onSubmit={handleAddTask}
            onClose={() => setIsOpenAddEditModal(false)}
            modalType={modalType}
            setModalType={setModalType}
            taskPositionType={taskPositionType}
            selectedTask={previousTask}
            projectId={projectId}
            templateName={TaskTemplates?.[activeTab]?.name}
          />
        </Modal>
      )}

      {isBulkCreateModalOpen && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={95}
          name={bulkMode === 'edit' ? 'Bulk Edit Group Tasks' : 'Bulk Create Group Task Templates'}
          onClose={() => setIsBulkCreateModalOpen(false)}>
          <BulkCreateGroupTaskTemplate
            isSubmitting={isSubmitting}
            onSubmit={handleBulkCreateTasks}
            onClose={() => setIsBulkCreateModalOpen(false)}
            projectId={projectId}
            templateName={bulkCreateTemplateName}
            data={tasks}
            mode={bulkMode}
          />
        </Modal>
      )}

      {isOpenAddWTModal && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={45}
          name="Add WorkType"
          onClose={() => setIsOpenAddWTModal(false)}>
          <AddEditWorkType
            isSubmitting={isSubmitting}
            onSubmit={handleAddWT}
            onClose={() => setIsOpenAddWTModal(false)}
            modalType={modalType}
            setModalType={setModalType}
          />
        </Modal>
      )}

      {/* WorkType Selection Modal */}
      {isOpenSelectWTModal && (
        <Modal
          isDirty
          confirmOnClose
          width={45}
          name={`Select WorkType to ${buttonType === 'edit' ? 'Edit' : 'Delete'}`}
          onClose={() => setIsOpenSelectWTModal(false)}>
          <div className="flex flex-col gap-4">
            {/* Disclaimer */}
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4">
              <div className="flex items-start gap-2">
                <div className="text-yellow-600 text-sm">⚠️</div>
                <div className="text-sm text-yellow-800">
                  <strong>Note:</strong> Only custom WorkTypes can be{' '}
                  {buttonType === 'edit' ? 'edited' : 'deleted'}. Default WorkTypes are
                  system-managed and cannot be modified.
                </div>
              </div>
            </div>

            <div className="max-h-60 overflow-y-auto">
              {transformedDataWorkTypes
                ?.filter((item) => item.is_added)
                ?.map((workType) => (
                  <div
                    key={workType.id}
                    className="p-3 border rounded-lg cursor-pointer hover:bg-gray-50 mb-2 transition-colors"
                    onClick={() => handleWorkTypeSelection(workType)}>
                    <div className="font-medium text-gray-900">{workType.label}</div>
                    <div className="text-sm text-gray-500">ID: {workType.id}</div>
                  </div>
                ))}
            </div>
            {transformedDataWorkTypes?.length === 0 && (
              <div className="text-center text-gray-500 py-8">
                No custom WorkTypes available to {buttonType === 'edit' ? 'edit' : 'delete'}
              </div>
            )}
          </div>
        </Modal>
      )}

      {/* Edit WorkType Modal */}
      {isOpenEditWTModal && (
        <Modal
          isDirty
          confirmOnClose
          width={45}
          name="Edit WorkType"
          onClose={() => {
            setIsOpenEditWTModal(false);
            setSelectedWorkType(null);
          }}>
          <AddEditWorkType
            isSubmitting={isSubmitting}
            onSubmit={handleEditWT}
            onClose={() => {
              setIsOpenEditWTModal(false);
              setSelectedWorkType(null);
            }}
            modalType="Edit"
            setModalType={setModalType}
            selectedTask={selectedWorkType}
          />
        </Modal>
      )}

      {canDelete === 'no' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Cannot delete '${resData?.name || 'this workType'}'`}
          onClose={() => setCanDelete(null)}
          width={45}>
          <div className="flex flex-col justify-center align-center ">
            <p className="text-center">Tasks are already present under this worktype</p>
          </div>
        </Modal>
      )}

      {canDelete === 'yes' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Confirmation'}
          onClose={() => {
            setCanDelete(null);
            setSelectedIds([]);
          }}
          width={45}>
          <DeleteConfirmationModal
            name={resData.name}
            title={'workType'}
            onClose={() => setCanDelete(null)}
            data={transformedDataWorkTypes.filter((item) => item.is_added === true)}
            type={'workType'}
            setCanDelete={setCanDelete}
            onDeleteClick={HandleDelete}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
          />
        </Modal>
      )}

      {/* Tabs */}
      {TaskTemplates && TaskTemplates.length > 0 && (
        <div className="mt-4 mb-6">
          <div className="flex gap-8 ">
            {TaskTemplates.map((template, index) => (
              <button
                key={template.id}
                className={`text-0.8rem] font-semibold transition-colors duration-200 relative ${
                  activeTab === index ? 'text-[#2A565E]' : 'text-gray-400 hover:text-gray-600'
                }`}
                onClick={() => handleTabChange(index)}>
                {template.name || `Template ${index + 1}`}
                {activeTab === index && (
                  <div className="absolute -bottom-2 left-0 right-0 h-[2px] bg-[#2A565E] transition-all duration-300" />
                )}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Floating Action Button */}
      <div
        className="fixed bottom-8 right-8 z-50"
        onMouseEnter={() => {
          if (hoverTimeout) {
            clearTimeout(hoverTimeout);
            setHoverTimeout(null);
          }
          setIsExpanded(true);
        }}
        onMouseLeave={() => {
          const timeout = setTimeout(() => {
            setIsExpanded(false);
          }, 200); // 200ms delay before collapsing
          setHoverTimeout(timeout);
        }}>
        <div className="relative">
          {/* Expanded Options Container */}
          {isExpanded && (
            <div
              className="absolute bottom-16 right-0 flex flex-col gap-3 pointer-events-auto items-end"
              onMouseEnter={() => {
                if (hoverTimeout) {
                  clearTimeout(hoverTimeout);
                  setHoverTimeout(null);
                }
              }}
              onMouseLeave={() => {
                const timeout = setTimeout(() => {
                  setIsExpanded(false);
                }, 200);
                setHoverTimeout(timeout);
              }}>
              {/* Delete Option */}
              <div className="flex items-center justify-center gap-3 whitespace-nowrap">
                <span className="text-sm font-medium text-white bg-black px-3 py-2 rounded flex items-center">
                  Delete WorkType
                </span>
                <button
                  onClick={handleDeleteWorkTypeClick}
                  className="flex items-center justify-center w-10 h-10 rounded-full bg-red-500 hover:bg-red-600 transition-colors duration-200 shadow-lg border-0">
                  <Trash size={16} className="text-white" />
                </button>
              </div>

              {/* Edit Option */}
              <div className="flex items-center justify-center gap-3 whitespace-nowrap">
                <span className="text-sm font-medium text-white bg-black px-3 py-2 rounded flex items-center">
                  Edit WorkType
                </span>
                <button
                  onClick={handleEditWorkTypeClick}
                  className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-500 hover:bg-blue-600 transition-colors duration-200 shadow-lg border-0">
                  <Pencil size={16} className="text-white" />
                </button>
              </div>

              {/* Bulk Edit Tasks Option */}
              {tasks && tasks.length > 0 && (
                <div className="flex items-center justify-center gap-3 whitespace-nowrap">
                  <span className="text-sm font-medium text-white bg-black px-3 py-2 rounded flex items-center">
                    Bulk Edit Tasks
                  </span>
                  <button
                    onClick={() => {
                      mixpanel.track('Bulk Edit Group Tasks Button Clicked', {
                        user_id: userId,
                        location: 'floating_button',
                        timestamp: new Date().toISOString()
                      });
                      setBulkMode('edit');
                      setIsBulkCreateModalOpen(true);
                    }}
                    className="flex items-center justify-center w-10 h-10 rounded-full bg-green-500 hover:bg-green-600 transition-colors duration-200 shadow-lg border-0">
                    <CirclePlus size={16} className="text-white" />
                  </button>
                </div>
              )}
            </div>
          )}

          {/* Main Button */}
          <Button
            displayType="primary"
            onClick={() => {
              // Track add work type button click
              mixpanel.track('Add WorkType Button Clicked', {
                user_id: userId,
                location: 'floating_button',
                timestamp: new Date().toISOString()
              });
              setIsOpenAddWTModal(true);
              setModalType('Add');
            }}
            customStyle={{
              borderRadius: '50%',
              width: '56px',
              height: '56px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
              transition: 'all 0.3s ease',
              position: 'relative',
              zIndex: 10
            }}>
            <Plus size={24} color="white" />
          </Button>
        </div>
      </div>

      <div className="overflow-auto rounded-lg shadow border relative">
        <table
          className="w-full rounded-t-xl text-left table-fixed"
          style={{ tableLayout: 'fixed' }}>
          <thead className=" bg-gray-200 !text-gray-600 ">
            <tr className="font-normal h-[3rem]">
              <th
                className="px-2 py-2 border-b font-normal relative"
                style={{ width: '15%' }}
                ref={worktypeHeaderRef}>
                <div className="flex items-center gap-1">
                  Work Type
                  <button
                    className="ml-1 align-middle"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenDropdown(openDropdown === 'worktype' ? null : 'worktype');
                    }}>
                    <ChevronDown size={16} />
                  </button>
                </div>
                {openDropdown === 'worktype' && (
                  <div
                    className="absolute bg-white border rounded shadow z-[1000]"
                    style={{
                      position: 'fixed',
                      top: worktypeHeaderRef.current?.getBoundingClientRect().bottom + 'px',
                      left: worktypeHeaderRef.current?.getBoundingClientRect().left + 'px',
                      minWidth: '200px',
                      maxHeight: '300px',
                      overflowY: 'auto'
                    }}
                    onClick={(e) => e.stopPropagation()}>
                    {[
                      {
                        id: '',
                        name: worktypeFilter ? 'Clear Filter' : 'Select WorkType'
                      },
                      ...transformedDataWorkTypes
                    ].map((wt, idx) => (
                      <div
                        key={wt.id || idx}
                        className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${
                          (wt.id === '' && !worktypeFilter) ||
                          (wt.id && wt.id === parseInt(worktypeFilter))
                            ? 'bg-blue-50 text-blue-600 font-medium'
                            : ''
                        }`}
                        onClick={() => {
                          setWorktypeFilter(wt.id || '');
                          setOpenDropdown(null);
                        }}>
                        {wt.label || wt.name}
                      </div>
                    ))}
                  </div>
                )}
              </th>
              {/* <th className="px-3 py-2 border-b font-normal ">Task ID</th> */}
              <th className="px-3 py-2 border-b font-normal" style={{ width: '25%' }}>
                Task Name
              </th>
              <th className="px-3 py-2 border-b font-normal" style={{ width: '10%' }}>
                Duration
              </th>
              <th className="px-3 py-2 border-b font-normal" style={{ width: '20%' }}>
                Dependent Tasks
              </th>
              <th className="px-3 py-2 border-b relative font-normal" style={{ width: '10%' }}>
                <div className="flex items-center gap-1">
                  Idle Time
                  <InfoIcon
                    className="w-4 h-4 text-gray-500 cursor-pointer"
                    onClick={() => {
                      // Track idle time info toggle
                      mixpanel.track('Group Idle Time Info Toggled', {
                        user_id: userId,
                        action: showIdleInfo ? 'hide' : 'show',
                        timestamp: new Date().toISOString()
                      });
                      setShowIdleInfo(!showIdleInfo);
                    }}
                  />
                </div>
                {showIdleInfo && (
                  <div className="absolute top-11 left-0 bg-white shadow p-2 text-xs rounded-lg border w-60 z-10">
                    <div className="flex items-start gap-2">
                      <InfoIcon className="w-4 h-4 mt-0.5 text-gray-400" />
                      <span>Time taken to complete the task</span>
                    </div>
                  </div>
                )}
              </th>
              <th className="px-3 py-2 border-b font-normal" style={{ width: '10%' }}>
                Drawing Required
              </th>
              <th className="px-3 py-2 border-b font-normal" style={{ width: '10%' }}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {formatted?.map((task) => {
              return (
                <tr key={task.id} className="border-b hover:bg-gray-50 bg-white h-[3.5rem]">
                  <td className="px-4 py-2 truncate" title={task.workType?.name}>
                    {task.workType?.name}
                  </td>
                  <td className="px-4 py-2 truncate" title={task.name}>
                    {task.name}
                  </td>
                  <td className="px-4 py-2">{`${task.duration} day${task.duration > 1 ? 's' : ''}`}</td>
                  <td
                    className="px-4 py-2 truncate"
                    title={
                      (task.dependencies?.map((item) => item.dependency?.name) || []).join(', ') ||
                      '-'
                    }>
                    {(task.dependencies?.map((item) => item.dependency?.name) || []).join(', ') ||
                      '-'}
                  </td>
                  <td className="px-4 py-2">{`${task.delay} day${task.delay > 1 ? 's' : ''}`}</td>
                  <td className="px-4 py-2">{task.drawing_required ? 'Yes' : 'No'}</td>
                  <td className="px-4 py-2 flex space-x-2 items-center text-gray-600">
                    <Pencil
                      className="w-4 h-4 cursor-pointer hover:text-blue-500"
                      onClick={() => {
                        // Track main task edit button click
                        mixpanel.track('Group Main Task Edit Button Clicked', {
                          user_id: userId,
                          task_id: task.id,
                          task_name: task.name,
                          work_type: task.workType?.name,
                          position_type: 'First',
                          timestamp: new Date().toISOString()
                        });
                        handleOnEdit(task.id);
                        setTaskPositionType('First');
                      }}
                    />
                    <Trash
                      className="w-4 h-4 hover:text-red-400 cursor-pointer"
                      onClick={() => {
                        // Track main task delete button click
                        mixpanel.track('Group Main Task Delete Button Clicked', {
                          user_id: userId,
                          task_id: task.id,
                          task_name: task.name,
                          work_type: task.workType?.name,
                          timestamp: new Date().toISOString()
                        });
                        setSelectedTask(task.id);
                        setOpenDeleteModal(true);
                      }}
                    />
                    <div className="relative group">
                      <Plus
                        className="w-4 h-4 cursor-pointer hover:text-purple-500"
                        onClick={() => {
                          // Track add new task button click for main task
                          mixpanel.track('Group Add New Task Button Clicked', {
                            user_id: userId,
                            previous_task_id: task.id,
                            previous_task_name: task.name,
                            work_type: task.workType?.name,
                            position_type: 'First',
                            timestamp: new Date().toISOString()
                          });
                          setIsOpenAddEditModal(true);
                          setModalType('Add');
                          setPreviousTask(task);
                          setTaskPositionType('First');
                        }}
                      />
                      <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 whitespace-nowrap text-xs bg-black text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                        Add new task
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
            {workTypesWithoutTasks.map((wt) => (
              <tr key={wt.id} className="border-b bg-gray-100 text-gray-500 h-[3.5rem]">
                <td className="px-4 py-2">{wt.label}</td>
                <td className="px-4 py-2">--</td>
                <td className="px-4 py-2">--</td>
                <td className="px-4 py-2">--</td>
                <td className="px-4 py-2">--</td>
                <td className="px-4 py-2">--</td>
                <td className="px-4 py-2 flex space-x-2 items-center">
                  <Plus
                    className="w-4 h-4 cursor-pointer hover:text-purple-500"
                    onClick={() => {
                      // Track add task button click for work types without tasks
                      mixpanel.track('Group Add Task to WorkType Button Clicked', {
                        user_id: userId,
                        work_type_id: wt.id,
                        work_type_name: wt.label,
                        position_type: 'First',
                        timestamp: new Date().toISOString()
                      });
                      SetWorkTypeId(wt.id);
                      setModalType('Add');
                      setIsOpenAddEditModal(true);
                      setTaskPositionType('First');
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GroupTasks;
